import React from 'react';
import { Link } from 'gatsby';
import { HexGrid, Layout, Text } from 'react-hexgrid';
import { WrapperMobile, WrapperDesktop, Canvas, Hex } from './styles';

export default function Assessments() {
  const layout = {
    mobile: [
      { q: -1, r: 0, s: 0, name: ['Air quality'], link: '/assessments/air-quality' },
      { q: 0, r: -1, s: 0, name: ['Biodiversity'], link: '/assessments/biodiversity' },
      { q: 1, r: -1, s: 0, name: ['Climate'], link: '/assessments/climate' },
      { q: -1, r: 1, s: 0, name: ['Cultural', 'heritage'], link: '/assessments/cultural-heritage' },
      { q: 0, r: 0, s: 0, name: ['Geology', 'and soils'], link: '/assessments/geology-and-soils' },
      { q: 1, r: 0, s: 0, name: ['Landscape', 'and visual'], link: '/assessments/landscape-and-visual' },
      { q: -1, r: 2, s: 0, name: ['Material', 'assets and', 'waste'], link: '/assessments/material-assets-and-waste' },
      { q: 0, r: 1, s: 0, name: ['Noise', 'and vibration'], link: '/assessments/noise-and-vibration' },
      { q: 1, r: 1, s: 0, name: ['Population', 'and human', 'health'], link: '/assessments/population-and-human-health' },
      { q: 0, r: 2, s: 0, name: ['Road drainage', 'and the water', 'environment'], link: '/assessments/road-drainage-and-the-water-environment' },
    ],
    desktop: [
      { q: 0, r: -1, s: 0, name: ['Air quality'], link: '/assessments/air-quality' },
      { q: 1, r: -1, s: 0, name: ['Biodiversity'], link: '/assessments/biodiversity' },
      { q: 2, r: -1, s: 0, name: ['Climate'], link: '/assessments/climate' },
      { q: -1, r: 0, s: 0, name: ['Cultural', 'heritage'], link: '/assessments/cultural-heritage' },
      { q: 0, r: 0, s: 0, name: ['Geology', 'and soils'], link: '/assessments/geology-and-soils' },
      { q: 1, r: 0, s: 0, name: ['Landscape', 'and visual'], link: '/assessments/landscape-and-visual' },
      { q: 2, r: 0, s: 0, name: ['Material', 'assets and', 'waste'], link: '/assessments/material-assets-and-waste' },
      { q: -1, r: 1, s: 0, name: ['Noise', 'and vibration'], link: '/assessments/noise-and-vibration' },
      { q: 0, r: 1, s: 0, name: ['Population', 'and human', 'health'], link: '/assessments/population-and-human-health' },
      { q: 1, r: 1, s: 0, name: ['Road drainage', 'and the water', 'environment'], link: '/assessments/road-drainage-and-the-water-environment' },
    ],
  };
  const startingTextPosition = [ 0.3, -0.2, -0.8 ]; 

  return (
    <>
      <WrapperMobile>
        <Canvas height="1" width="1" />
        <HexGrid width="100%" height="100%" viewBox="-40 -30 80 80">
          <Layout size={{ x: 10, y: 10 }} spacing={1.1} origin={{ x: 0, y: 0 }}>
            {layout.mobile.map(({ q, r, s, name, link }) => {
              return (
                <Link key={name} to={link}>
                  <Hex q={q} r={r} s={s}>
                    {name.map((text, idx, arr) => {
                      const position = startingTextPosition[arr.length - 1] + (idx * 1);
                      const y = "".concat(position, 'em');
                      return (
                        <Text key={text} y={y}>
                          {text}
                        </Text>
                      );
                    })}
                  </Hex>
                </Link>                
              );
            })}
          </Layout>
        </HexGrid>
      </WrapperMobile>
      <WrapperDesktop>
        <Canvas height="3" width="4" />
        <HexGrid width="100%" height="100%" viewBox="-30 -30 80 60">
          <Layout size={{ x: 10, y: 10 }} flat={false} spacing={1.1} origin={{ x: 0, y: 0 }}>
            {layout.desktop.map(({ q, r, s, name, link }) => {
              return (
                <Link key={name.join(' ')} to={link}>
                  <Hex q={q} r={r} s={s}>
                    {name.map((text, idx, arr) => {
                      const position = startingTextPosition[arr.length - 1] + (idx * 1);
                      const y = "".concat(position, 'em');
                      return (
                        <Text key={text} y={y}>
                          {text}
                        </Text>
                      );
                    })}
                  </Hex>
                </Link> 
              );
            })}
          </Layout>
        </HexGrid>
      </WrapperDesktop>
    </>
  );
}